import { LocationStrategy, PathLocationStrategy, DatePipe } from '@angular/common';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, JsonpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';

import {
  MatAutocompleteModule,
  MatButtonModule,
  MatToolbarModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatFormFieldModule,
  MatInputModule,
  MatNativeDateModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,

} from '@angular/material';
import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserModule } from '@angular/platform-browser';
import { MatTableModule } from '@angular/material/table';
 import { MatPaginatorModule } from '@angular/material/paginator';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
// import { TreeModule } from 'angular-tree-component';
import { ImageUploadModule } from 'angular2-image-upload';
import {
  DefaultWidgetRegistry,
  SchemaFormModule,
  WidgetRegistry,
} from 'angular2-schema-form';
import 'd3';
import { NvD3Module } from 'ng2-nvd3';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { CookieService } from 'ngx-cookie-service';
import { LoadingModule } from 'ngx-loading';
import 'nvd3';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';

import { AppRoutes } from './app.routing';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { CompanyUserComponent } from './company-user/company-user.component';
import { EquipmentsComponent } from './equipments/equipments.component';
import { FooterComponent } from './footer/footer.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { JournalComponent } from './journal/journal.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { ManageJournalComponent } from './manage-journal/manage-journal.component';
import { NavbarComponent } from './navbar/navbar.component';
import { ProcedureCompComponent } from './procedure-comp/procedure-comp.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { RegisterComponent } from './register/register.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { SafePipe } from './safeHtml.pipe';
import { AppWideUser, Token } from './Services/AppUserProfile';
import { Login } from './Services/login-service';
import { NavigationService } from './Services/navigation.service';
import { RouteTrackerService } from './Services/route-tracker.service';
import { SrubUpService } from './Services/ScrubUp.service';
import { ShowErrorsComponent } from './show-errors/show-errors.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SpecialityComponent } from './speciality/speciality.component';
import { SurgeonlistComponent } from './surgeonlist/surgeonlist.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { ManageContactComponent } from './manage-contact/manage-contact.component';
import { ProfessionalTrainingComponent } from './professional-training/professional-training.component';
import { ImpersonationComponent } from './impersonation/impersonation.component';
import { ManageApprovalComponent } from './manage-approval/manage-approval.component';
import { UserSpecialityComponent } from './user-speciality/user-speciality.component';
import { UserProcedureComponent } from './user-procedure/user-procedure.component';
import { SurgeonProceduresComponent } from './surgeon-procedures/surgeon-procedures.component';
import { ShiftDaytimeComponent } from './shift-daytime/shift-daytime.component';
import { ReleaseSpecialityComponent } from './release-speciality/release-speciality.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { ProcedureUserCompComponent } from './procedure-user-comp/procedure-user-comp.component';
import { UserRoleComponent } from './user-role/user-role.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { ProcedureReportComponent } from './procedure-report/procedure-report.component';
import { SurgeonReportComponent } from './surgeon-report/surgeon-report.component';
import { SpecialitiesReportComponent } from './specialities-report/specialities-report.component';
 import { ChartsModule } from 'ng4-charts/ng4-charts';
import { UserComponent } from './users/user.component';
import {VerifyAccountComponent} from "./verify-account/verify-account.component";
import { SubscriptionComponent } from './subscription/subscription.component';
import { SubscriptionUpdateComponent } from './subscription/subscription-update.component';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    ResetPasswordComponent,
    LoginComponent,
    SidebarComponent,
    LayoutComponent,
    NavbarComponent,
    FooterComponent,
    CompanyUserComponent,
    ShowErrorsComponent,
    ForgotPasswordComponent,
    SurgeonProceduresComponent,
    ChangePasswordComponent,
    TermsConditionComponent,
    SpecialityComponent,
    ProcedureComponent,
    EquipmentsComponent,
    SafePipe,
    ProcedureCompComponent,
    RegisterComponent,
    SurgeonlistComponent,
    JournalComponent,
    ManageJournalComponent,
    ManageContactComponent,
    ProfessionalTrainingComponent,
    ImpersonationComponent,
    ManageApprovalComponent,
    UserSpecialityComponent,
    UserProcedureComponent,
    ShiftDaytimeComponent,
    ReleaseSpecialityComponent,
    AnalyticsComponent,
    ProcedureUserCompComponent,
    UserRoleComponent,
    StatisticsComponent,
    ProcedureReportComponent,
    SurgeonReportComponent,
    SpecialitiesReportComponent,
    UserComponent,
    VerifyAccountComponent,
    SubscriptionComponent,
    SubscriptionUpdateComponent
  ],
  imports: [
    ChartsModule,
    ImageUploadModule.forRoot(),
    LoadingModule,

    Ng4LoadingSpinnerModule,
    SchemaFormModule.forRoot(),
    RouterModule.forRoot(AppRoutes, { useHash: false }),
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    JsonpModule,
    FormsModule,
    MatSnackBarModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatToolbarModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatProgressBarModule,
    MatTooltipModule,
    NvD3Module,
    MatSidenavModule,
    MatMenuModule,
    MatDatepickerModule, MatTableModule, MatSortModule, MatPaginatorModule,
    MatNativeDateModule, ReactiveFormsModule,
  ],
  exports: [
    SafePipe,
    MatToolbarModule,
    MatSidenavModule,
    MatDatepickerModule,
    MatTableModule, MatSortModule, MatPaginatorModule,
    MatNativeDateModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    RouterModule,
    MatButtonModule,
    MatChipsModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatAutocompleteModule,

  ],
  providers: [
    DatePipe,
    Login,
    AppWideUser,
    Token,
    CookieService,
    AppConfig,
    NavigationService,
    RouteTrackerService,
    SrubUpService,
    { provide: WidgetRegistry, useClass: DefaultWidgetRegistry },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/app.module.ts